import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../api';

const getServices = async (id, search, cityId, isAvailable, minRating) => {
    const query = supabase
        .from('services_view')
        .select(`*, salon(*), menu_category(name)`)
        .eq('is_available', isAvailable);

    if (id) query.eq('menu_category', id);
    if (search) query.ilike('name', `%${search}%`);
    if (cityId) query.eq('city', cityId);
    if (minRating) query.gte('avg_rank', minRating);

    const { data, error } = await query;
    if (error) throw new Error(error.message);
    return data;
};

export default function useGetServicesView(
    id?: string,
    search?: string,
    cityId?: number,
    isAvailable?: boolean,
    minRating?: number,
) {
    return useQuery({
        queryKey: ['useGetServicesView', id, search, cityId, isAvailable, minRating],
        queryFn: () => getServices(id, search, cityId, isAvailable, minRating),
        staleTime: 0,
    });
}